import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/seats/license.seats.holders.query.gql"
import type {
  LicenseSeatHoldersQuery,
  LicenseSeatHoldersQueryVariables,
} from "@/v2-backoffice-client/license/seats/__types__/license.seats.holders.query"

type Options = QueryHookOptions<
  LicenseSeatHoldersQuery,
  LicenseSeatHoldersQueryVariables
>

/**
 * Every seat held across one customer's seated licenses, by name. One read
 * the panel's tabs group per license (Licensing, Feature access) or per
 * person (Users, the "show access for" picker); the same variables share
 * one cache entry, and a grant or revoke evicts it.
 */
export function useLicenseSeatHoldersQuery(options: Options) {
  return useQuery<LicenseSeatHoldersQuery, LicenseSeatHoldersQueryVariables>(
    query,
    options,
  )
}
